
import { Textarea } from '@/components/ui/textarea';
import { FormFieldWrapper } from '@/components/ui/form-field-wrapper';
import { formPlaceholders } from '@/data/formPlaceholders';

interface TransactionDescriptionFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

export const TransactionDescriptionField = ({ value, onChange, error, disabled }: TransactionDescriptionFieldProps) => {
  const handleChange = (newValue: string) => {
    if (newValue.length <= 100) {
      onChange(newValue);
    }
  };

  return (
    <FormFieldWrapper 
      label="Descrição (Opcional)" 
      required={false}
      error={error}
    >
      <div className="relative">
        <Textarea 
          id="description" 
          placeholder={formPlaceholders.transactionDescription} 
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          className={`input-enhanced resize-none ${error ? 'border-destructive' : ''}`}
          rows={3} 
          disabled={disabled}
          maxLength={100}
        />
        <div className="absolute bottom-2 right-2 text-xs text-muted-foreground">
          {value.length}/100
        </div>
      </div>
    </FormFieldWrapper>
  );
};
